import axios from "axios";
import { API_BASE_URL } from "../../../config";

export const getBusinessProfileDataWithBID = async (businessId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/BusinessProfile/getBusinessProfileForMessageWithBID`, {
            params: {
                businessId,
            },
        });
        console.log("biz profile: ", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching getBusinessProfileDataWithBID:", error);
        throw error;
    }
};
